module.exports = __webpack_public_path__ + "82b190e8cc73f3301f53a97610107faa.pdf";